import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { COMMON_WEB_PATH, COMMON_WEB_PATH_JP } from "../../../constant";
import { REPLACE_AIR } from "../../../replace_str_constant";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useCheckLogin from "../../../hook/useCheckLogin";
import { notice } from "../../../redux/action/action";
import useDeviceType from "../../../hook/useDeviceType";
import { getRankingList } from "../../../api/getApi";
import { formatNumber } from "../../../utils/formatNumber";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RankingNumberCount from "./RankingNumberCount";
import useIsLandScapeMachine from "../../../hook/useIsLandScapeMachine";

const TopGameBoard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const splideRef = useRef();

  const [rankingList, setRankingList] = useState([]);

  const isMobile = useDeviceType() === "Mobile";
  const dispatch = useDispatch();
  const { isLogin } = useCheckLogin();
  const navigate = useNavigate();

  const isLandScapeMachine = useIsLandScapeMachine();

  const handleEnterGame = useCallback(
    (gameItem) => {
      const { platform, game_name_en, game_uid } = gameItem || {};
      if (!isLogin) {
        dispatch(
          notice({
            title: i18n("Please login first"),
            type: "error",
          }),
        );
        navigate("signin");
        return;
      }

      if (isMobile) {
        navigate(`game-confirm/${game_name_en}/${platform}/${game_uid}`);
      } else {
        navigate(`/gamebox/${game_name_en}/${platform}/${game_uid}`);
      }
    },
    [isLogin, navigate, dispatch, isMobile, i18next.language],
  );

  useEffect(() => {
    if (window?.profit_ranking_status === 1) {
      getRankingList().then((data) => {
        const result = data?.data;

        const topThree = result;
        setRankingList(topThree);
      });
    }
  }, []);
  return (
    <>
      {/* 在 md 以上使用垂直列表 */}
      <Box
        display={isLandScapeMachine ? "none" : { base: "none", md: "block" }}
        w="100%"
        overflowY="auto" // 啟用垂直滾動
        className="no-scrollbar" // 隱藏滾動條但保持功能
        pr="10px" // 為滾動條預留空間
      >
        <Flex
          direction="column"
          gap={{
            base: "10px",
            md: "0px",
          }}
          w="100%"
        >
          {rankingList?.map((item, index) => {
            const { platform, game_code, profit } = item;
            return (
              <Box
                key={index}
                //bg={boxBg}
                display={"flex"}
                h="90px"
                alignItems={"center"}
                bgImage={`url(${COMMON_WEB_PATH}/now888/rank/top_${
                  index + 1
                }__.png)`}
                bgSize="100% 100%"
                bgPos="center"
                bgRepeat="no-repeat"
                gap="10px"
                w="full"
                cursor="pointer"
                _last={{ borderBottom: "none" }} // 最後一個元素不要邊框
                _hover={{
                  // 添加 hover 效果
                  transform: "translateX(5px)",
                  transition: "all 0.2s",
                }}
                onClick={() => handleEnterGame(item)}
              >
                <Box
                  alignItems={"center"}
                  display="flex"
                  gap="5px"
                  overflow={"hidden"}
                  justifyContent={"space-between"}
                  w="100%"
                  h="100%"
                  pl="33%"
                  pr="50px"
                >
                  <Flex gap="10px" alignItems={"center"}>
                    <LazyLoadImage
                      className={
                        "min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px] rounded-full"
                      }
                      src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                        game_code,
                      )}.webp`}
                    />
                  </Flex>
                  <Flex
                    flex={1}
                    overflow="hidden"
                    direction={"column"}
                    alignItems={"flex-end"}
                    mb="10px"
                  >
                    <Flex
                      ml="auto"
                      fontWeight={900}
                      color="#6F3D07"
                      className="text-overflow"
                    >
                      {item?.[`game_name_en`] || "-"}
                      {/* <Text
                        className="text-overflow"
                        fontSize="18px"
                        color="white"
                        fontWeight={500}
                      >
                        {item?.[`game_name_en`] || "-"}
                      </Text> */}
                    </Flex>
                    <Flex
                      fontSize="18px"
                      color="#fff"
                      alignItems={"center"}
                      gap="5px"
                      fontWeight={700}
                    >
                      <Text
                        sx={{
                          WebkitTextStroke: "0.2px #632616",
                        }}
                      >
                        {formatNumber(profit, {
                          point: false,
                        })}
                      </Text>
                    </Flex>
                  </Flex>
                </Box>
              </Box>
            );
          })}
        </Flex>
      </Box>

      {/* 在 md 以下使用原有的水平輪播 */}
      <Box display={{ base: "block", md: "none" }}>
        <Splide
          ref={splideRef}
          options={{
            pagination: false,
            arrows: false,
            drag: "free",
            perPage: 3,
            // perMove: 1,
            gap: "0px",
            lazyLoad: "nearby",

            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
          }}
        >
          {rankingList?.map((item, index) => {
            const { platform, game_code, profit } = item;
            return (
              <SplideSlide>
                <Box
                  //bg={boxBg}
                  bgImage={`url(${COMMON_WEB_PATH}/now888/rank/top_${
                    index + 1
                  }__.png)`}
                  bgSize="100% 100%"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  display={"flex"}
                  h={{
                    base: "40px",
                  }}
                  alignItems={"center"}
                  gap="10px"
                  cursor={"pointer"}
                  onClick={() => handleEnterGame(item)}
                  pl="40px"
                  pr="7px"
                >
                  <Box
                    alignItems={"center"}
                    display="flex"
                    gap="5px"
                    overflow={"hidden"}
                  >
                    <LazyLoadImage
                      className={
                        "min-w-[30px] min-h-[30px] max-w-[30px] max-h-[30px] rounded-full"
                      }
                      src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                        game_code,
                      )}.webp`}
                    />

                    <Box>
                      <Text
                        className="text-overflow"
                        fontSize="12px"
                        fontWeight={700}
                        color="#582D0C"
                      >
                        {item?.[`game_name_en`] || "-"}
                      </Text>
                      <Flex
                        fontSize="10px"
                        color="#fff"
                        alignItems={"center"}
                        gap="2.5px"
                        fontWeight={700}
                      >
                        {/* <Icon color="#fff" as={RiUserFill} /> */}

                        <Text
                          sx={{
                            WebkitTextStroke: "0.2px #632616",
                          }}
                          color="#fff"
                        >
                          {" "}
                          <RankingNumberCount value={profit} />
                        </Text>
                      </Flex>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            );
          })}
        </Splide>
      </Box>

      <Box
        bgImage={`url(${COMMON_WEB_PATH}/now888/rank/ranking_wrapper_.png)`}
        bgSize="100%100%"
        bgPos={"center"}
        bgRepeat="no-repeat"
        h="140px"
        w="100%"
        pt="15px"
        display={isLandScapeMachine ? "flex" : "none"}
        justifyContent={"center"}
        alignItems={"center"}
        px="1em"
      >
        <Splide
          ref={splideRef}
          className="w-full"
          options={{
            pagination: false,
            arrows: false,
            drag: "free",
            perPage: 3,
            // perMove: 1,
            gap: "5px",
            lazyLoad: "nearby",
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
          }}
        >
          {rankingList?.map((item, index) => {
            const { platform, game_code, profit } = item;
            return (
              <SplideSlide>
                <Box
                  //bg={boxBg}
                  bgImage={`url(${COMMON_WEB_PATH}/now888/rank/ranking_tag.png)`}
                  bgSize="100% 100%"
                  bgPos="center"
                  bgRepeat="no-repeat"
                  display={"flex"}
                  h={{
                    base: "100px",
                  }}
                  alignItems={"center"}
                  gap="10px"
                  cursor={"pointer"}
                  // onClick={() => handleEnterGame(item)}
                  pl="2em"
                  pr="2em"
                >
                  <Box
                    alignItems={"center"}
                    display="flex"
                    gap="10px"
                    overflow={"hidden"}
                    w="100%"
                  >
                    <LazyLoadImage
                      className={
                        "min-w-[65px] min-h-[65px] max-w-[65px] max-h-[65px] rounded-full"
                      }
                      src={`${COMMON_WEB_PATH_JP}/game-icon-ds88/en/${platform}/${REPLACE_AIR(
                        game_code,
                      )}.webp`}
                    />

                    <Box flex={1}>
                      <Text
                        className="text-overflow"
                        fontSize="1.3em"
                        fontWeight={700}
                        color="#582D0C"
                      >
                        {item?.[`game_name_en`] || "-"}
                      </Text>
                      <Flex
                        fontSize="16px"
                        color="#fff"
                        alignItems={"center"}
                        gap="2.5px"
                        fontWeight={700}
                        borderRadius={"30px"}
                        p="5px"
                        bg="#633E09"
                        w="120px"
                      >
                        <Image
                          src={`${COMMON_WEB_PATH}/now888/rank/ranking_star.png`}
                        />

                        <Text
                          sx={{
                            WebkitTextStroke: "0.2px #632616",
                          }}
                          color="#fff"
                        >
                          {" "}
                          {formatNumber(profit, {
                            point: false,
                          })}
                        </Text>
                      </Flex>
                    </Box>
                  </Box>
                </Box>
              </SplideSlide>
            );
          })}
        </Splide>
      </Box>
    </>
  );
};

export default TopGameBoard;
